import { REFINERY_NAME } from "@/constant";

const state = {
    refineryName: 'ALL',
    isAllCardActive: true,
    isIrpcCardActive: false,
    isSprcCardActive: false,
    isTopCardActive: false,
    isBcpCardActive: false,
    isPttgcCardActive: false,
    isEssoCardActive: false,
}

const getters = {

};

const actions = {
    activeRefineryCard(context,refineryName){
        context.commit("ACTIVE_REFINERY_CARD", refineryName);
    },
    fetchRefName(context, data) {
        context.commit("SET_REF_NAME", data);
    },
};

const mutations = {
    SET_REF_NAME(state, data) {
        state.refineryName = data;
      },
    ACTIVE_REFINERY_CARD (state,refineryName){
        state.refineryName = refineryName;
        switch (refineryName) {
            case REFINERY_NAME.ALL:
                state.isAllCardActive = true;
                state.isIrpcCardActive = false;
                state.isSprcCardActive = false;
                state.isTopCardActive = false;
                state.isBcpCardActive = false;
                state.isPttgcCardActive = false;
                state.isEssoCardActive = false;
                break;
            case REFINERY_NAME.IRPC:
                state.isAllCardActive = false;
                state.isIrpcCardActive = true;
                state.isSprcCardActive = false;
                state.isTopCardActive = false;
                state.isBcpCardActive = false;
                state.isPttgcCardActive = false;
                state.isEssoCardActive = false;
                break;
            case REFINERY_NAME.SPRC:
                state.isAllCardActive = false;
                state.isIrpcCardActive = false;
                state.isSprcCardActive = true;
                state.isTopCardActive = false;
                state.isBcpCardActive = false;
                state.isPttgcCardActive = false;
                state.isEssoCardActive = false;
                break;
            case REFINERY_NAME.TOP:
                state.isAllCardActive = false;
                state.isIrpcCardActive = false;
                state.isSprcCardActive = false;
                state.isTopCardActive = true;
                state.isBcpCardActive = false;
                state.isPttgcCardActive = false;
                state.isEssoCardActive = false;
                break;
            case REFINERY_NAME.BCP:
                state.isAllCardActive = false;
                state.isIrpcCardActive = false;
                state.isSprcCardActive = false;
                state.isTopCardActive = false;
                state.isBcpCardActive = true;
                state.isPttgcCardActive = false;
                state.isEssoCardActive = false;
                break;
            case REFINERY_NAME.PTTGC:
                state.isAllCardActive = false;
                state.isIrpcCardActive = false;
                state.isSprcCardActive = false;
                state.isTopCardActive = false;
                state.isBcpCardActive = false;
                state.isPttgcCardActive = true;
                state.isEssoCardActive = false;
                break;
            case REFINERY_NAME.ESSO:
                state.isAllCardActive = false;
                state.isIrpcCardActive = false;
                state.isSprcCardActive = false;
                state.isTopCardActive = false;
                state.isBcpCardActive = false;
                state.isPttgcCardActive = false;
                state.isEssoCardActive = true;
                break;
        default:
        }
      }
};

export default {
    state,
    getters,
    actions,
    mutations,
  };